import React from "react"
import Flex from "@irati/ui/src/Flex"
import {RecognitionAutomation} from "@irati/types"
import AutomationCountryItem from "./AutomationCountryItem"
interface AutomationCountryListProps {
  recognitionAutomations: RecognitionAutomation[]
}
const AutomationCountryList = (props: AutomationCountryListProps) => {
  return (
    <Flex direction="column" gap={2} marginTop={2}>
      {props.recognitionAutomations?.map((recognitionAutomation) => (
        <AutomationCountryItem key={recognitionAutomation.uuid} recognitionAutomation={recognitionAutomation} />
      ))}
    </Flex>
  )
}

export default AutomationCountryList
